.root {
  display: inline-block;
  position: relative;
}

.trigger {
  align-items: center;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: var(--color-muted, #6b7280);
  cursor: pointer;
  display: inline-flex;
  height: 28px;
  justify-content: center;
  padding: 0;
  transition: background 0.15s, color 0.15s;
  width: 28px;
}

.trigger:hover {
  background: var(--color-secondary, #f3f4f6);
  color: var(--color-foreground);
}

